export const METHOD_GET = 'GET';
export const METHOD_PUT = 'PUT';
export const METHOD_POST = 'POST';
export const METHOD_PATCH = 'PATCH';
export const METHOD_DELETE = 'DELETE';

export const APIS = {
	// auth
	user: 'users',
	ChangePassword: 'auth/change-password',
	RegistrierungsAnfrage: 'registrierungsanfrages',
	faq: 'faqs',
	boradcastNachricht: 'broadcast45nachrichts',
	// Registerierung
	Hochschule: 'hochschules',
	// Förderprogramm
	Foerderrichtlinie: 'foerderrichtlinies',
	FörderProgramme: 'foerderprogramms',
	CallForProposals: 'callforproposals',
	keywords: 'keywords',
	//Stammdaten
	Person: 'persons',
	Organisation: 'organisations',
	Antragsberechtigte: 'antragsberechtigtes',
	// Antrag
	Antrag: 'antrags',
	Foerderantrag: 'foerderantrags',
	Mittelabruf: 'mittelabrufs',
	Zwischenbericht: 'zwischenberichts',
	Verwendungsnachweis: 'verwendungsnachweiss',
	Abschlussbericht: 'abschlussberichts',
	Kostenkategorie: 'kostenkategories',
	Leistungsgruppe: 'leistungsgruppes',
	Kostenposition: 'kostenpositions',
	Nachweisposition: 'nachweispositions',
	StundenNachwies: 'stundennachweiss',
	Abschreibung: 'abschreibungs',
	'Portal-Nachricht': 'nachrichts',
	AenderungsAnfrage: 'aenderungsanfrages',
	// Push-Notification
	PushNotificaiton: 'push-notifications',
	// Allgemeine
	AllgemeinHinweiseKMU: 'allgemeinehinweisekmus',
	AllgemeinHinweiseDeminimis: 'allgemeinehinweisede45minimiss',
	AllgemeinHinweisRus: 'rus-selbsterklaerungs',
	AllgemeinHinweisBeihilferelevanz: 'beihilferelevanz45erklaerungs',
	Eingang: 'eingangs',
};
